import { render, staticRenderFns } from "./BigQueryBillForm.vue?vue&type=template&id=59089879&scoped=true"
import script from "./BigQueryBillForm.vue?vue&type=script&lang=js"
export * from "./BigQueryBillForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59089879",
  null
  
)

export default component.exports